<template>

  <div>

      <div v-if="project" class="project-wrapper">

          <!--
          kacheln und phasen entwerfen bzw. generelles layout
          projekttitel bearbeiten
          projekte löschen
          -->

        <project-sidebar @projectDescriptionChange="projectDescriptionChange($event)" @projectTitleChange="projectTitleChange($event)" @back="back"></project-sidebar>

        <div class="project-content" @click="reset">
          <div class="project-connectionLines" ref="lines">
            <connection-line v-for="(line, index) in lines" v-bind:key="index" :statement="line.statement" :statementLine="line.statementLine" :x="line.x" :y="line.y" :length="line.length" :orientation="line.orientation">
            </connection-line>
          </div>
          <div class="project-phases">
            <div class="project-phases-add" @click="newPhaseDialog()">Neuen Abschnitt hinzufügen &raquo;</div>
            <div v-for="(phase, index) in orderedPhases()" :order="phase.order" v-bind:key="index" ref="phase" v-if="pItems" class="project-list-wrapper">
              <h3 v-bind:class="{ 'disabled': connections }">{{phase.order}}. <blur-editable :content="phase.title" @change="changePhaseTitle($event, phase['.key'])"></blur-editable> <div class="project-phases-title-delete" @click="phaseDelete(phase['.key'])"  v-if="phasePosts(phase['.key']).length <= 0"><svgicon :icon="'delete'" width="32" height="32" color="#334274"></svgicon></div></h3>
              <div class="project-list">
                <project-list-item v-for="post in phasePosts(phase['.key'])" @addConnection="addConnection(post['.key'])" @removeConnection="removeConnection(post['.key'])" :phase="phase.order" ref="projectListItemRefs" @remove="removePost(post['.key'])" :item="post" v-bind:key="post['.key']" :id="post['.key']"  @click="showConnections(post['.key'])" :currentPhase="currentPhase" >
                  {{post.title}}
                </project-list-item>
                <div class="projectlist-item projectlist-item-add" v-if="connections" v-bind:class="{ 'disabled': connections }">
                  <svgicon :icon="'add'" width="48" height="48" color="#334274"></svgicon>
                </div>
                <div class="projectlist-item projectlist-item-add"  v-if="!connections" @click="$emit('mapSelect', phase['.key'])" v-bind:class="{ 'disabled': connections }">
                  <svgicon :icon="'add'" width="48" height="48" color="#334274"></svgicon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <phase-create-new v-if="newPhase" @abortCreateNew="newPhase = false" @setNew="createNewPhase($event)"></phase-create-new>
      </div>
  </div>

</template>

<script>
import firebase from 'firebase/app'
import VueAwesomplete from 'vue-awesomplete'
import AwesompleteCss from 'awesomplete/awesomplete.css' // eslint-disable-line
import ProjectListItem from '@/components/ProjectListItem'
import ProjectSidebar from '@/components/ProjectSidebar'
import ConnectionLine from '@/components/ConnectionLine'
import PhaseCreateNew from '@/components/PhaseCreateNew'
// import Editable from '@/components/Editable' // eslint-disable-line
import BlurEditable from '@/components/BlurEditable' // eslint-disable-line
import _ from 'lodash'

var db = firebase.database()
var postsRef = db.ref('posts')
var projectsRef = db.ref('projects')
var iconsRef = db.ref('icons')

export default {
  name: 'Project',
  props: ['project'],
  components: {
    VueAwesomplete,
    ConnectionLine,
    ProjectListItem,
    ProjectSidebar,
    PhaseCreateNew,
    BlurEditable
  },
  data () {
    return {
      value: '',
      connected: [],
      currentPhase: false,
      connections: false,
      newPhase: false,
      lines: [

      ]
    }
  },
  methods: {
    selectItem () {
      this.$nextTick(() => {
        projectsRef.child(this.project['.key']).child('items').child(this.value).set({
          phase: false
        })
        this.$refs.skills.internalValue = null
        document.activeElement.blur()
      })
    },
    newPhaseDialog () {
      this.newPhase = true
    },
    createNewPhase (data) {
      projectsRef.child(this.project['.key']).child('phases').push({
        order: this.phases.length + 1,
        title: data.title
      })
      this.newPhase = false
    },
    changePhaseTitle (title, phase) {
      projectsRef.child(this.project['.key']).child('phases').child(phase).child('title').set(title)
    },
    projectTitleChange (title) {
      if (title.length > 3) {
        projectsRef.child(this.project['.key']).child('title').set(title)
      }
    },
    projectDescriptionChange (title) {
      if (title.length > 3) {
        projectsRef.child(this.project['.key']).child('description').set(title)
      }
    },
    addConnection (index) {
      let tempPostIndex = this.connected[0]
      projectsRef.child(this.project['.key']).child('items').child(this.connected[0]).child('origins').push({
        id: index
      })
      this.lines = []
      this.connected = []
      this.currentPhase = false
      this.connections = false
      this.$nextTick(() => {
        this.showConnections(tempPostIndex)
      })
    },
    removePost (key) {
      projectsRef.child(this.project['.key']).child('items').child(key).remove()
    },
    phaseDelete (key) {
      var r = confirm('Sind Sie wirklich sicher diesen Abschnitt unwiederruflich zu löschen?')
      if (r === true) {
        projectsRef.child(this.project['.key']).child('phases').child(key).remove()
      }
    },
    removeConnection (index) {
      let origins = _.find(this.$refs.projectListItemRefs, {id: this.connected[0]}).item.origins
      let item = _.findKey(origins, {id: index})
      let tempPostIndex = this.connected[0]
      // delete modal einbauen im item
      projectsRef.child(this.project['.key']).child('items').child(this.connected[0]).child('origins').child(item).remove()
      this.lines = []
      this.connected = []
      this.currentPhase = false
      this.connections = false
      this.$nextTick(() => {
        this.showConnections(tempPostIndex)
      })
    },
    showConnections (index) {
      if (index === this.connected[0]) {
        this.lines = []
        this.connected = []
        this.currentPhase = false
        this.connections = false
      } else {
        this.lines = []
        this.connected = []
        this.currentPhase = _.find(this.$refs.projectListItemRefs, {id: index}).phase
        this.connections = true

        // Prüfen ob Verbindung überhaupt noch vorhanden bzw. Ende und Ziel und falls nicht entsprechende Verbindung löschen

        let origins = _.find(this.$refs.projectListItemRefs, {id: index}).item.origins

        const rectStart = _.find(this.$refs.projectListItemRefs, {id: index}).$el.getBoundingClientRect()
        const rectStartOffsetTop = _.find(this.$refs.projectListItemRefs, {id: index}).$el.offsetTop
        const rectStartOffsetLeft = _.find(this.$refs.projectListItemRefs, {id: index}).$el.offsetLeft

        this.connected.push(index)

        if (origins !== undefined) {
          let self = this
          _.forEach(origins, function (target) {
            const rectEndOffsetTop = _.find(self.$refs.projectListItemRefs, {id: target.id}).$el.offsetTop
            const rectEndOffsetLeft = _.find(self.$refs.projectListItemRefs, {id: target.id}).$el.offsetLeft
            self.connected.push(target.id)

            const firstLine = {
              x: rectStartOffsetLeft + rectStart.width / 2,
              y: rectStartOffsetTop + rectStart.height + 6,
              length: ((rectEndOffsetTop - rectStartOffsetTop - rectStart.height) / 2) - 10,
              orientation: 'vertical',
              statement: '',
              statementLine: false
            }
            self.lines.push(firstLine)
            const secondLine = {
              x: firstLine.x,
              y: firstLine.y + firstLine.length,
              length: rectEndOffsetLeft - rectStartOffsetLeft,
              orientation: 'horizontal',
              statement: false,
              statementLine: false
            }
            self.lines.push(secondLine)
            const thirdLine = {
              x: secondLine.x + secondLine.length,
              y: secondLine.y,
              length: rectEndOffsetTop - secondLine.y - 11,
              orientation: 'vertical',
              statement: target.statement,
              statementLine: { project: self.project['.key'], origin: index, target: _.findKey(origins, {id: target.id}) }
            }
            self.lines.push(thirdLine)
          })
        }
      }
    },
    reset () {
      // if (this.connected.length > 0) {
      //   this.lines = []
      //   this.connected = []
      // }
    },
    back () {
      this.$emit('back', true)
    },
    remove (item) {
      db.ref('projects/' + this.project['.key'] + '/items').child(item).remove()
    },
    phasePosts (phase) {
      let dataPosts = this.projectPosts() // eslint-disable-line
      let self = this
      if (phase) {
        dataPosts = _.filter(dataPosts, function (v) {
          if (self.pItems[v['.key']].phase === phase) {
            v.origins = self.pItems[v['.key']].origins
            v.added = self.pItems[v['.key']].added
            return self.pItems[v['.key']]
          }
        })
        dataPosts = _.orderBy(dataPosts, ['added'], ['asc'])
        return dataPosts
      }
    },
    orderedPhases () {
      let phases = this.phases
      _.forEach(phases, function (value, key) {
        value.key = key
      })
      return _.orderBy(phases, function (p) {
        return p.order
      }, ['desc'])
    },
    projectPosts () {
      let dataPosts = this.posts // eslint-disable-line
      let self = this
      dataPosts = _.filter(dataPosts, function (v) { return self.pItems[v['.key']] })
      return dataPosts
    }
  },
  firebase () {
    return {
      posts: postsRef,
      projects: projectsRef,
      icons: iconsRef,
      projectTitle: {
        source: db.ref('projects').child(this.project['.key']).child('title'),
        asObject: true
      },
      projectDescription: {
        source: db.ref('projects').child(this.project['.key']).child('description'),
        asObject: true
      },
      pItems: {
        source: db.ref('projects/' + this.project['.key'] + '/items'),
        asObject: true
      },
      phases: db.ref('projects').child(this.project['.key']).child('phases')
    }
  },
  computed: {
    // orderedPhases: function () {
    //   let phases = this.phases
    //   _.forEach(phases, function (value, key) {
    //     value.key = key
    //   })
    //   return _.orderBy(phases, function (p) {
    //     return p.order
    //   }, ['desc'])
    // }
  }
}
</script>

<style lang="scss">

.project-connectionLines {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
}

.project-wrapper {
  display:flex;
  margin: -20px -50px -50px;
  height: 100vh;
  overflow: hidden;
}

.project-content {
  padding: 20px 50px 50px;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: relative;
  height: 100vh;
  flex-basis: auto;
  flex-grow: 1;
  // position: absolute;
  .project-list-wrapper > h3 {
    display: inline-block;
    background: $color-highlight;
    margin-top: 15px;
    letter-spacing: 0.5px;
    // color: $color-;
    color: $color-text;
    padding: 10px 15px;
    position: relative;
    font-weight: 400;
    // opacity: 0.35;
    margin-bottom: 0;
    user-select: none;
    &.disabled {
      opacity: 0.1;
    }
    .project-phases-title-delete {
      position: absolute;
      right: -38px;
      top: 8px;
      opacity: 0.5;
      svg path {
        fill: $color-grey;
        cursor: pointer;
      }
    }
  }
}

.project-list {

  display: flex;
  // justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 100%;
  margin-left: -12.5px;
  // width: 960px;
}

.project-list-wrapper {
  & + .project-list-wrapper {
    border-top: 1px dashed rgba($color-action, 0.5);
    margin-top: 75px;
    padding-top: 50px;
  }
}

.project-phases {
  padding-bottom: 100px;
}

.project-phases-add {
  border: 1px dashed rgba($color-action, 0.5);
  user-select: none;
  cursor: pointer;
  text-transform: uppercase;
  svg {
    margin-top: -4px;
  }
  &:hover {
    opacity: 1;
    border: 1px dashed rgba($color-action, 0.25);
  }
  text-align: center;
  // font-weight: bold;
  color: $color-action;
  opacity: 0.5;
  padding: 15px 0;
  margin-bottom: 20px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Project.vue